import { render } from "./InvoiceItem.vue?vue&type=template&id=754b0af7&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"

import "./InvoiceItem.vue?vue&type=style&index=0&id=754b0af7&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754b0af7"]])

export default __exports__